// extracted by mini-css-extract-plugin
module.exports = {"root":"ShimmerImage_root__t2C_C","hide":"ShimmerImage_hide__xD__0","show":"ShimmerImage_show__mpG9i","shimmer":"ShimmerImage_shimmer__TrJxU","hidden":"ShimmerImage_hidden__hNbq0"};